/**
 * System Types
 *
 * Types for system-level entities that are not organization-specific.
 */
export const GLOBAL_CONFIG = 'GlobalConfig';
export const SESSION = 'Session';
//# sourceMappingURL=system.js.map